let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5HwID")).then(() => parcelRequire('9d4ex'));